<!--<app-sidenav [collapsed]="sideNavVisible$ | async"></app-sidenav>-->
<div class="content flex">
  <p class="govuk-body-l">This Organisation is already registered for Public Procurement Gateway. Contact your Organisation Administrator</p>
  <p><a routerLink="/manage-org/register/search">Search with a different organisation ID</a></p>
  <p><a href="https://www.gca.gov.uk/contact" target="_blank">Contact GCA</a></p>
</div>
